import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import {Button, Form, Input, InputGroup, InputGroupText, Label, Progress} from "reactstrap";
import AppUploadIcon from "../../../media/app-images/AppUploadIcon.mjs";
import FolderUploader from "../../../controls/FolderUploader/FolderUploader.mjs";
import "../../MultiLoader.css";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import AppGestionePerimetriIcon from "../../../media/app-images/AppGestionePerimetriIcon.mjs";
import AppFlagTrueIcon from "../../../media/app-images/AppFlagTrueIcon.mjs";
import AppFlagFalseIcon from "../../../media/app-images/AppFlagFalseIcon.mjs";
import AppEquivalencesIcon from "../../../media/app-images/AppEquivalencesIcon.mjs";
import "./RealPeriUpload.css";
import appLib from "../../../libs/appLib.mjs";
import ModalProgress from "../../../controls/ModalProgress/ModalProgress.mjs";

const prefix = "RealPeriUpload";

const RealPeriUpload = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage(),
			files: [],
			step: 1,
		}
		this.uid = Glob.generateUid(prefix);
		this.parseFiles = this.parseFiles.bind(this);
		this.gotoParent = this.gotoParent.bind(this);
		this.renderLoader = this.renderLoader.bind(this);
		this.renderForm  = this.renderForm.bind(this);
		this.startUploadProcess = this.startUploadProcess.bind(this);
		this.uploadNextFile = this.uploadNextFile.bind(this);
		this.loader = this.loader.bind(this);
	}
	componentDidMount() {
		Glob.setStatus('pageTitle', ['Perimeters','Upload real data']);
		Glob.setStatus('pageIcon',<AppPerimeterIcon /> );
		Glob.register('Prefs', ()=>{
			const lang = Glob.getLanguage();
			if ( lang !== this.state.lang ) this.setState({ lang: lang } );
		}, this.uid)
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	gotoParent() {
		Glob.gotoPage('Perimeters');
	}

	startUploadProcess() {
		const loading = {
			message: <span><TextLabel value={'Creating perimeter'} />…</span>,
			numOfFiles: this.state.files.length,
			totalSize: this.state.files.reduce( (s,file)=>(s+file.size),0 ),
			doneSize: 0,
			index: 0,
			over: false,
			color: 'warning'
		};
		const firstStep = Math.round( loading.totalSize / 10 );
		loading.totalSize += firstStep;
		return new Promise( resolve => {
			this.setState({ loading: loading }, async ()=>{
				loading.id = (await appLib.api('realperiload/create', { name: this.state.name, description: this.state.description }))?.id;
				loading.doneSize = firstStep /2;
				this.setState({ loading: loading }, async ()=> {
					await appLib.api('realperiload/equivalences', { id: loading.id, equivalences: this.state.equivalences });
					loading.doneSize = firstStep /2;
					this.setState({ loading: loading }, resolve );
				});
			});
		});
	}
	uploadNextFile() {
		const loading = this.state.loading;
		const file = this.state.files[loading?.index ?? 0];
		if ( ! file ) {
			return new Promise( resolve => {
				loading.over = true;
				loading.message = <span><TextLabel value={'Operation completed'} /></span>;
				loading.color = 'success';
				this.setState( {loading: loading}, ()=>{
					setTimeout( resolve, 1000 );
				});
			});
		}
		return new Promise( resolve => {
			loading.index += 1;
			loading.color = 'primary';
			loading.message = (<>
				<small><strong>{loading.index}</strong>/{loading.numOfFiles}</small>
				<tt>{file.filePath.replace(/^[^/]+\//,"")}</tt>
			</>);
			loading.doneSize += file.size;
			this.setState( {loading: loading}, ()=>{
				appLib.api(
					"realperiload/loadsubject",
					{ id: loading.id, prefix: file.prefix, content: file.json }
				).then( resolve );
			} );
		});
	}
	async loader() {
		if ( ! this.state.loading ) await this.startUploadProcess();
		while ( ! this.state.loading?.over ) {
			await this.uploadNextFile();
		}
		const loading = this.state.loading;
		loading.finalizing = true;
		this.setState({ loading: loading }, ()=> {
			appLib.api("realperiload/finalize", { id: this.state.loading.id}).then( (res) =>{
				loading.finalized = !! res?.done;
				this.setState({ loading: loading }, () => {
					setTimeout( () => {
						if ( loading.finalized ) {
							this.gotoParent();
						} else {
							this.setState({ loading: false });
						}
					}, 2000)
				})
			})
		});
	}
	parseFiles(files) {
		if ( ! files || !files.length ) {
			this.setState({ name: "", description: "", files: [] });
			return;
		}
		const ns = {};
		if ( ! this.state.name ) ns.name = files[0].filePath.split('/').shift();
		ns.files = files.map( f  =>{
			f.prefix = f.filePath.split('/').map( pc => pc.replace(/\|/g,'').trim() ).join('|').replace(/^.*\|([^|]+\|[^|]+)$/,"$1");
			return f;
		});
		this.setState( ns);
	}
	renderLoader() {
		return (
			<div className="panel-content limited">
				<div className="loading">
					<div className={"message"}>
						{ this.state.loading?.message }
					</div>
					<div className={"upload-progress"}>
						<Progress
							animated
							striped
							color={ this.state.loading?.color }
							max={this.state.loading?.totalSize ?? 100}
							value={ this.state.loading?.doneSize ?? 0 }
						/>
					</div>
					{ ( !! this.state.loading?.finalizing ) && (
						<ModalProgress
							title={<><AppPerimeterIcon /> <TextLabel value={"Loading" } /></>}
							success={ this.state.loading?.finalized }
						/>
					)}
				</div>
			</div>
		)
	}
	renderForm() {
		return(
			<>
				<div className={"panel-content limited form"}>
					<Form
						onSubmit={ e => {
							e.preventDefault();
						}}
					>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Name"} />:
								</Label>
							</InputGroupText>
							<Input
								value={this.state.name||""}
								onChange={ e => {
									this.setState({ name: e.target.value });
								}}
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Description"} />:
								</Label>
							</InputGroupText>
							<Input
								type={"textarea"}
								value={this.state.description||""}
								onChange={ e => {
									this.setState({ description: e.target.value });
								}}
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Equivalences"}/>:
								</Label>
							</InputGroupText>
							<InputGroupText className={"flex-grow-1 justify-content-evenly"}>
								<Button
									className={"btn-icon"}
									color={ this.state.json ? "danger" : "primary"}
									onClick={ async ()=> {
										const d = this.state.json ? false : (await Glob.uploadJSON())?.json;
										if ( Array.isArray(d?.equivalences) ) {
											this.setState({equivalences: d.equivalences ? d.equivalences : false});
										}
									}}
								>
									<b>
										<TextLabel value={this.state.json ? "Delete" : "Choose..." } />
									</b>
									<i>
										<AppEquivalencesIcon />
									</i>
								</Button>
								<Label>
									{ this.state.equivalences ? <AppFlagTrueIcon style={{height:"var(--icon-size)"}}/> : <AppFlagFalseIcon style={{height:"var(--icon-size)"}} /> }
								</Label>
							</InputGroupText>
						</InputGroup>
						<FolderUploader
							title={"Perimeter data"}
							single={true}
							accept={['pjson']}
							onChange={ this.parseFiles }
						/>
					</Form>
				</div>
				<div className={"panel-footer"}>
					<Button
						className={"btn-icon"}
						color="success"
						onClick={ () => { Glob.gotoPage('Perimeters'); } }
					>
						<i>
							<AppGestionePerimetriIcon />
						</i>
						<b>
							<TextLabel value={"Available perimeters"}/>
						</b>
					</Button>
					<Button
						className={"btn-icon"}
						color={"primary"}
						disabled={ this.state.loading || ! this.state.equivalences || ! (this.state.files && this.state.files.length > 0) }
						onClick={ this.loader }
					>
						<b>
							<TextLabel value={"Save"} />
						</b>
						<i>
							<AppUploadIcon />
						</i>
					</Button>
				</div>
			</>
		)
	}
	render() {
		return (
			<SliderPanel
				icon={ <AppUploadIcon /> }
				title={ <TextLabel value={"Upload real data"}/> }
				className={prefix+' MultiLoader'}
			>
				{ this.state.loading ? this.renderLoader() : this.renderForm() }
			</SliderPanel>
		)
	}
}

export default RealPeriUpload;